

import React from "react";
import { MdProductionQuantityLimits } from "react-icons/md";
import { TbScanPosition } from "react-icons/tb";
import { GoAlert } from "react-icons/go";
import { HiTrendingUp } from "react-icons/hi";
import { FaNotesMedical } from "react-icons/fa6";

export default function Icons({ name, showAddPanel }) {
  const handleDragStart = (e) => {
    e.dataTransfer.setData("panel", name);
  };

  const getIcon = () => {
    if (name === "Order") return <MdProductionQuantityLimits size={18} />;
    if (name === "Position") return <TbScanPosition size={18} />;
    if (name === "Alert") return <GoAlert size={18} />;
    if (name === "TradeNow") return <HiTrendingUp size={18} />;
    if (name === "Note") return <FaNotesMedical size={18} />;
    return null;
  };

  const iconColor = "text-gray-600 dark:text-gray-400";

  return (
    <div 
      draggable
      onDragStart={handleDragStart}
      className={`flex items-center ${
        showAddPanel ? "justify-start px-2" : "justify-center px-2"
      } gap-2 py-2 cursor-grab hover:bg-gray-100 dark:hover:bg-gray-800 rounded transition group`}
    >
      <div className={iconColor}>
        {getIcon()}
      </div>
      {showAddPanel && (
        <span className="text-xs font-sans text-gray-700 dark:text-gray-300 truncate">
          {name}
        </span>
      )}
    </div>
  );
} 




